import React from 'react'
import { Record } from 'immutable'

import TOKEN_MARK from './TOKEN_MARK'

function defaultOnlyIn(node) {
	return node.object === 'block' && node.type === 'code_block'
}

function defaultGetSyntax() {
	return 'javascript'
}

function defaultRenderDecoration(props, editor, next) {
	const { children, decoration } = props

	if (decoration.type !== TOKEN_MARK) {
		return next()
	}

	const className = decoration.data.get('className')

	return <span className={className}>{children}</span>
}

// The plugin options
class Options extends Record({
	onlyIn: defaultOnlyIn,
	getSyntax: defaultGetSyntax,
	renderDecoration: defaultRenderDecoration,
}) {}

export default Options
